(function () {
  'use strict';

  var SECTION_SELECTOR = '.oddit-popup-newsletter';
  var keydownHandlers = new WeakMap();

  function initPopup(section) {
    if (!section || section.dataset.initialized === 'true') return;
    section.dataset.initialized = 'true';

    var initialState = section.querySelector('[data-popup-state="initial"]');
    var emailState = section.querySelector('[data-popup-state="email"]');
    var nextButton = section.querySelector('[data-popup-next]');
    var closeButtons = section.querySelectorAll('[data-popup-close]');
    var form = section.querySelector('.oddit-popup-newsletter__form');
    var emailInput = section.querySelector('.oddit-popup-newsletter__email');

    function openPopup() {
      section.removeAttribute('hidden');
      section.classList.remove('is-closed');
      section.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function closePopup() {
      section.classList.add('is-closed');
      section.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    function showEmailState() {
      if (!initialState || !emailState) return;
      initialState.hidden = true;
      emailState.hidden = false;
      if (emailInput) {
        requestAnimationFrame(function () {
          emailInput.focus();
        });
      }
    }

    if (nextButton) {
      nextButton.addEventListener('click', function (e) {
        e.preventDefault();
        showEmailState();
      });
    }

    Array.prototype.forEach.call(closeButtons, function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        closePopup();
      });
    });

    if (form) {
      form.addEventListener('submit', function (e) {
        if (!emailInput || !emailInput.value) return;
        // Allow native Shopify customer-form submission; close optimistically.
        closePopup();
      });
    }

    var onKeydown = function (e) {
      if (e.key === 'Escape' && section.getAttribute('aria-hidden') === 'false') {
        closePopup();
      }
    };
    keydownHandlers.set(section, onKeydown);
    document.addEventListener('keydown', onKeydown);

    var delaySeconds = parseInt(section.dataset.popupDelay, 10);
    if (isNaN(delaySeconds) || delaySeconds < 0) delaySeconds = 0;
    setTimeout(openPopup, delaySeconds * 1000);
  }

  function destroyPopup(section) {
    if (!section) return;
    var handler = keydownHandlers.get(section);
    if (handler) {
      document.removeEventListener('keydown', handler);
      keydownHandlers.delete(section);
    }
    document.body.style.overflow = '';
  }

  function initAll(root) {
    var scope = root || document;
    var sections = scope.querySelectorAll(SECTION_SELECTOR);
    Array.prototype.forEach.call(sections, initPopup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var sections = e.target.querySelectorAll(SECTION_SELECTOR);
    Array.prototype.forEach.call(sections, destroyPopup);
  });
})();
